import type { TemplateCategory } from '@dataTypes/templateCategories'

export const TEMPLATE_CATEGORIES: TemplateCategory[] = [
  {
    text: 'Anesthesia',
    value: 'Anesthesia',
    subcategories: [
      { text: 'Local Anesthesia', value: 'Anesthesia_Local' },
      { text: 'General Anesthesia', value: 'Anesthesia_General' },
      { text: 'Sedation', value: 'Anesthesia_Sedation' },
    ],
  },
  {
    text: 'Consultation',
    value: 'Consultation',
    subcategories: [
      { text: 'Initial Consultation', value: 'Consultation_Initial' },
      { text: 'Follow-up Consultation', value: 'Consultation_FollowUp' },
      { text: 'Emergency Consultation', value: 'Consultation_Emergency' },
    ],
  },
  {
    text: 'Charting',
    value: 'Charting',
    subcategories: [
      { text: 'Periodontal Charting', value: 'Charting_Periodontal' },
      { text: 'Caries Charting', value: 'Charting_Caries' },
      { text: 'Restoration Charting', value: 'Charting_Restoration' },
    ],
  },
  {
    text: 'Diagnostics',
    value: 'Diagnostics',
    subcategories: [
      { text: 'X-Ray Analysis', value: 'Diagnostics_XRay' },
      { text: 'CBCT Scan', value: 'Diagnostics_CBCT' },
      { text: 'Intraoral Photos', value: 'Diagnostics_Photos' },
    ],
  },
  {
    text: 'Endodontics',
    value: 'Endodontics',
    subcategories: [
      { text: 'Root Canal Treatment', value: 'Endodontics_RCT' },
      { text: 'Retreatment', value: 'Endodontics_Retreatment' },
      { text: 'Apicoectomy', value: 'Endodontics_Apicoectomy' },
    ],
  },
  {
    text: 'Front Office',
    value: 'Front Office',
    subcategories: [
      { text: 'Appointment Scheduling', value: 'FrontOffice_Appointment' },
      { text: 'Insurance Verification', value: 'FrontOffice_Insurance' },
      { text: 'Payment Processing', value: 'FrontOffice_Payment' },
    ],
  },
  {
    text: 'Hygiene',
    value: 'Hygiene',
    subcategories: [
      { text: 'Prophylaxis', value: 'Hygiene_Prophylaxis' },
      { text: 'Scaling & Root Planing', value: 'Hygiene_SRP' },
      { text: 'Periodontal Maintenance', value: 'Hygiene_Maintenance' },
    ],
  },
  {
    text: 'Implant',
    value: 'Implant',
    subcategories: [
      { text: 'Implant Placement', value: 'Implant_Placement' },
      { text: 'Implant Restoration', value: 'Implant_Restoration' },
      { text: 'Bone Grafting', value: 'Implant_BoneGraft' },
    ],
  },
  {
    text: 'Orthodontics',
    value: 'Orthodontics',
    subcategories: [
      { text: 'Braces Adjustment', value: 'Orthodontics_Braces' },
      { text: 'Clear Aligners', value: 'Orthodontics_Aligners' },
      { text: 'Retainer Check', value: 'Orthodontics_Retainer' },
    ],
  },
  {
    text: 'Periodontics',
    value: 'Periodontics',
    subcategories: [
      { text: 'Gum Surgery', value: 'Periodontics_Surgery' },
      { text: 'Gum Grafting', value: 'Periodontics_Grafting' },
      { text: 'Pocket Reduction', value: 'Periodontics_PocketReduction' },
    ],
  },
  {
    text: 'Treatment',
    value: 'Treatment',
    subcategories: [
      { text: 'Bridge Prep', value: 'Treatment_BridgePrep' },
      { text: 'Crown Prep', value: 'Treatment_CrownPrep' },
      { text: 'Composite Restoration', value: 'Treatment_Composite' },
      { text: 'Inlay/Onlay', value: 'Treatment_InlayOnlay' },
      { text: 'Veneer Prep', value: 'Treatment_VeneerPrep' },
    ],
  },
  {
    text: 'Custom',
    value: 'Custom',
    subcategories: [{ text: '+ Add custom template', value: 'Custom_Add' }],
  },
]
